import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import closeIcon from "../../Assets/Svg/close-icon.svg";
import "./ActivityPopup.css";
import Http from "../../HttpClients/HttpClients";
import { BaseUrl } from "../../ApiBaseUrl/ApiBaseUrl";
import {
  GET_APPROVAL_CYCLE,
  GET_VENDOR_HISTORY_BY_ID,
} from "../../ApiEndPoints/ApiEndPoints";
import { toast } from "react-toastify";
import PageLoader from "../PageLoader/PageLoader";
import { useDispatch, useSelector } from "react-redux";
import { getVendorEditCycleAction } from "../../Store/actions/vendorMangementAction";
import { transformCycleData } from "../../Utils/Utils";
import ActivityCard from "./ActivityCard";
import EditCycle from "./EditCycle";
import TimeStampCycle from "./TimeStampCycle";

const ActivityPopup = ({ isOpen, closeModal, userData }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [viewDetails, setViewDetails] = useState(false);
  const [timeStampI, setTimeStampI] = useState(null);
  // const {
  //     loading,
  //   } = useSelector((state) => state.deleteParticularVendor);

  useEffect(() => {
    if (userData?.vendor_id) {
      const vendor_id = userData?.vendor_id;
      dispatch(getVendorEditCycleAction(vendor_id)).then((res) => {
        if (res?.status === 200) {
          setData(transformCycleData(res?.data?.data));
        }
      });
    }
  }, [isOpen === true]);

  const handleActivity = (index) => {
    setTimeStampI(index);
    setViewDetails(true);
  };

  const handleCloseDetails = () => {
    setViewDetails(false);
  };
  return (
    <div className="d-flex justify-content-center">
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className={`create-user-modal ac-time-stamp-modal`}
        overlayClassName="create-modal-overlay"
      >
        {viewDetails ? (
          <TimeStampCycle
            closeModal={handleCloseDetails}
            id={data?.[timeStampI]?.cycle_id}
            vendorId={userData?.vendor_id}
            totalDays={data?.[timeStampI]?.total}
          />
        ) : (
          <EditCycle
            closeModal={closeModal}
            closeIcon={closeIcon}
            data={data}
            handleActivity={handleActivity}
          />
        )}
      </Modal>
    </div>
  );
};

export default ActivityPopup;
